import { Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

export type ViewDrawerSectionTone = {
  accent: string;
  bg: string;
  icon: ReactNode;
};

export interface ViewDrawerSectionHeaderProps {
  tone: ViewDrawerSectionTone;
  label: string;
}

export function ViewDrawerSectionHeader({
  tone,
  label,
}: ViewDrawerSectionHeaderProps) {
  return (
    <Flex
      align="center"
      gap={10}
      style={{
        marginBottom: 12,
        padding: '8px 12px',
        borderRadius: 10,
        background: tone.bg,
        borderLeft: `3px solid ${tone.accent}`,
      }}
    >
      <span style={{ color: tone.accent, fontSize: 16 }}>{tone.icon}</span>
      <Typography.Text strong style={{ color: tone.accent, margin: 0 }}>
        {label}
      </Typography.Text>
    </Flex>
  );
}
